module.exports = __webpack_public_path__ + "img/UTS Logistics.af529b33.png";